
define('tmpl!core/templates/webidl/comment.html', ['deps/handlebars'], function (hb) { return hb.compile('<span class=\'idlSectionComment\'>{{extAttr obj indent true\n}}{{idn indent}}// {{comment}}</span>\n');});

